"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _showComponentsInViewport = _interopRequireDefault(require("./showComponentsInViewport"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var setLoadComplete = function setLoadComplete($component, callback) {
  if (typeof $component.addClass === 'function') {
    $component.addClass('component-ready');
  } else {
    $component.classList.add('component-ready');
  }

  (0, _showComponentsInViewport["default"])(window.pageYOffset);
  if (callback !== undefined) callback();
};

var _default = setLoadComplete;
exports["default"] = _default;